// src/features/pdf/pdf-reorder/components/DraggablePageList.tsx
import React from 'react';
import {
    DndContext,
    closestCenter,
    KeyboardSensor,
    PointerSensor,
    useSensor,
    useSensors,
    DragEndEvent,
} from '@dnd-kit/core';
import {
    arrayMove,
    SortableContext,
    rectSortingStrategy, // Use grid-friendly strategy
    sortableKeyboardCoordinates,
} from '@dnd-kit/sortable';
import { Box, Grid } from '@mui/material';
import DraggablePageItem from './DraggablePageItem';
import { DisplayPage } from '../hooks/usePdfReorder';


interface DraggablePageListProps {
    pages: DisplayPage[];
    onReorder: (event: DragEndEvent) => void;
    onDelete: (id: string) => void;
    onPreview: (id: string) => void;
}

const DraggablePageList: React.FC<DraggablePageListProps> = ({
                                                                 pages,
                                                                 onReorder,
                                                                 onDelete,
                                                                 onPreview
                                                             }) => {
    const sensors = useSensors(
        useSensor(PointerSensor),
        useSensor(KeyboardSensor, {
            coordinateGetter: sortableKeyboardCoordinates,
        })
    );

    const pageIds = pages.map(p => p.id);

    return (
        <DndContext
            sensors={sensors}
            collisionDetection={closestCenter}
            onDragEnd={onReorder}
        >
            <SortableContext items={pageIds} strategy={rectSortingStrategy}>
                <Box sx={{ width: '100%', mt: 2 }}>
                    <Grid container spacing={2} justifyContent="center">
                        {pages.map((page) => (
                            <Grid item key={page.id} {...{} as any}>
                                <DraggablePageItem
                                    id={page.id}
                                    originalPageNum={page.originalIndex + 1}
                                    finalPageNum={page.finalIndex}
                                    isDeleted={page.deleted}
                                    thumbnailUrl={page.thumbnailUrl}
                                    onDelete={onDelete}
                                    onPreview={onPreview}
                                />
                            </Grid>
                        ))}
                    </Grid>
                </Box>
            </SortableContext>
        </DndContext>
    );
};

export default DraggablePageList;